var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("Pricing.AuthorizedClient"),
        width: "440px",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "modal-append-to-body": false,
        "append-to-body": true,
        top: "5vh",
        "custom-class": "details-view customer-popup"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          { staticStyle: { "flex-direction": "column" } },
          [
            _c(
              "el-form",
              {
                staticStyle: { height: "70px" },
                attrs: { "label-width": "70px", "label-position": "right" }
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("Pricing.AuthorizedClient") } },
                  [
                    _c("cargo-company-select", {
                      attrs: {
                        no: "customerId",
                        "method-params": { customer: true, active: true },
                        "default-value": _vm.customerId
                      },
                      on: {
                        change: function(p) {
                          _vm.customerId = p.value
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              {
                staticStyle: { "text-align": "center" },
                attrs: { slot: "footer" },
                slot: "footer"
              },
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      no: "customerOkEventHandler",
                      type: "primary",
                      size: "mini"
                    },
                    on: { click: _vm.customerOkEventHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("Pricing.OK")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { no: "onCancel", size: "mini" },
                    on: { click: _vm.onCancel }
                  },
                  [_vm._v(_vm._s(_vm.$t("Pricing.CANCEL")))]
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }